module.exports = __webpack_public_path__ + "img/1-7.592c951e.png";